import React, { Fragment } from "react";
import Default from "./Default";

// AppHeader comes from Layout/AppMain/Layout — do not remount it here.
// Remounting reactstrap DropdownToggle on list→detail navigation causes React #185 / white screen.
const Besturen = () => {
    return (
        <Fragment>
            <Default />
        </Fragment>
    )
};

export default Besturen;